import * as React from "react";
import { SVGProps } from "react";
const SvgQuestion = (props: SVGProps<SVGSVGElement>) => (
  <svg width={95} height={95} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M50.538 53.897V52.79c0-2.373 1.002-3.48 4.693-5.59 4.035-2.32 5.748-4.93 5.748-8.754 0-6.618-5.431-10.863-13.869-10.863-8.754 0-14.132 4.509-14.132 11.786h9.808c.026-2.162 1.503-3.665 3.586-3.665 2.057 0 3.56 1.213 3.56 2.98 0 2.162-.87 3.11-4.615 5.273-3.665 2.11-4.878 4.482-4.218 9.308l.079.632h9.36Zm-4.482 13.158c3.797 0 5.932-1.846 5.932-5.142 0-3.322-2.135-5.168-5.932-5.168-3.77 0-5.933 1.846-5.933 5.168 0 3.296 2.162 5.142 5.933 5.142Z"
      fill="#FFF"
      fillRule="nonzero"
    />
  </svg>
);
export default SvgQuestion;
